// components/UsersDataTable.jsx
import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { useStateContext } from '../../Contexts/ContextProvider';

const UsersDataTable = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;
  const {data } = useStateContext () ; 

  if (!data) { 
    return <> no data provided </>
}
const title = "reports " ; 
const users = data ; 
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);

  const totalPages = Math.ceil(users.length / usersPerPage);

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(users);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Users');
    XLSX.writeFile(workbook, `${title.replace(/\s/g, "_")}.xlsx`);
  };

  return (
    <div className="bg-white p-3 mt-3 rounded shadow-sm">
      <h5>{title}</h5>
      <button className="btn btn-sm btn-success mb-2" onClick={exportToExcel}>
        Export to Excel
      </button>
      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th>#</th>
            <th>Full Name</th>
            <th>Email</th>
            <th>Country</th>
            <th>Status</th>
            <th>Position</th>
          </tr>
        </thead>
        <tbody>
          {currentUsers.map((user, index) => (
            <tr key={user._id || index}>
              <td>{indexOfFirstUser + index + 1}</td>
              <td>{user.fullname || user.name}</td>
              <td>{user.email}</td>
              <td>{user.country}</td>
              <td>{user.status}</td>
              <td>{user.position}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      <nav>
        <ul className="pagination justify-content-center">
          <li className={`page-item ${currentPage === 1 && 'disabled'}`}>
            <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>&laquo;</button>
          </li>
          {[...Array(totalPages)].map((_, idx) => (
            <li key={idx} className={`page-item ${currentPage === idx + 1 && 'active'}`}>
              <button className="page-link" onClick={() => setCurrentPage(idx + 1)}>{idx + 1}</button>
            </li>
          ))}
          <li className={`page-item ${currentPage === totalPages && 'disabled'}`}>
            <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>&raquo;</button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default UsersDataTable;
